import { SVGProps } from 'react'

interface HomeProps extends SVGProps<SVGSVGElement> {
}
export default function Home({ ...rest }: HomeProps) {
  return (
    <svg width="22" height="22" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M2.66797 13.4998V7.24984L1.46797 8.1665L0.667969 7.09984L2.66797 5.5665V3.49984H4.0013V4.54984L8.0013 1.49984L15.3346 7.09984L14.5346 8.14984L13.3346 7.24984V13.4998H2.66797ZM4.0013 12.1665H7.33464V9.49984H8.66797V12.1665H12.0013V6.23317L8.0013 3.18317L4.0013 6.23317V12.1665ZM2.66797 2.83317C2.66797 2.27761 2.86241 1.80539 3.2513 1.4165C3.64019 1.02761 4.11241 0.833171 4.66797 0.833171C4.85686 0.833171 5.01519 0.769282 5.14297 0.641504C5.27075 0.513726 5.33464 0.355393 5.33464 0.166504H6.66797C6.66797 0.722059 6.47352 1.19428 6.08464 1.58317C5.69575 1.97206 5.22352 2.1665 4.66797 2.1665C4.47908 2.1665 4.32075 2.23039 4.19297 2.35817C4.06519 2.48595 4.0013 2.64428 4.0013 2.83317H2.66797Z" fill="#6B7B3C"/>
    </svg>
  )
}
